var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M197 73l-16 -16 4 -4c10,-9 10,-25 0,-35 -10,-9 -26,-9 -35,0l-4 4 -16 -16c-8,-8 -21,-8 -29,0l-95 95c-8,8 -8,21 0,29l67 67c8,8 21,8 29,0l95 -95c8,-8 8,-21 0,-29zm-41 5c1,1 3,1 4,0l4 -3c0,1 -1,3 -2,4 -2,3 -6,3 -8,0 -2,-2 -2,-5 0,-7 2,-1 3,-2 5,-2l-3 3c-1,2 -1,4 0,5zm-2 -55c8,-7 19,-7 26,0 8,7 8,19 0,26l-3 4 -26 -26 3 -4 0 0zm-29 24c2,2 4,2 5,0l3 -3c0,2 0,4 -2,5 -2,2 -5,2 -7,0 -2,-2 -2,-6 0,-8 1,-1 3,-2 4,-1l-3 3c-1,1 -1,3 0,4zm-27 146c-6,5 -15,5 -20,0l-67 -68c-6,-5 -6,-14 0,-20l10 -10 87 88 -10 10zm14 -15l-87 -87 80 -80c6,-6 15,-6 20,0l16 16 -8 8c-4,-3 -10,-2 -14,2 -4,4 -4,12 0,16 5,5 12,5 17,0 4,-3 5,-9 2,-14l8 -8 26 26 -8 8c-5,-2 -10,-2 -14,2 -5,5 -5,12 0,17 4,5 12,5 17,0 3,-4 4,-10 2,-14l8 -8 16 16c5,5 5,14 0,20l-81 80 0 0zm31 -85c-1,-2 -2,-3 -4,-3l0 1c-2,0 -3,2 -3,3 0,1 1,2 1,2 1,1 2,1 3,1l0 0c2,-1 3,-2 3,-4zm-97 52l12 12c1,2 3,2 5,0 1,-1 1,-3 0,-4l-13 -12c-1,-2 -3,-2 -4,0 -2,1 -1,3 0,4zm94 -73c-1,-2 -2,-3 -4,-3l-60 14c-2,0 -3,2 -3,3 0,1 1,2 1,2 1,1 2,1 3,1l60 -14c2,0 3,-2 3,-3zm-75 16c0,-1 -2,-3 -4,-2l0 0c-2,0 -3,2 -3,4 0,0 1,1 1,1 1,1 2,1 3,1l0 0c2,0 3,-2 3,-4zm63 8c-1,-1 -2,-3 -4,-2l-60 13c-2,1 -3,2 -3,4 1,1 1,1 1,2 1,1 2,1 3,1l60 -14c2,0 3,-2 3,-4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceList);
export default __webpack_public_path__ + "static/media/PriceList.dac66b21648b1e40c71bd887331816f0.svg";
export { ForwardRef as ReactComponent };